/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseEditorialWrapperFragment} from '@amblique/contentful/app/contentful/fragments/editorial-wrapper/base-editorial-wrapper.fragment';
import {BaseContainerFragment} from '@amblique/contentful/app/contentful/fragments/container/base-container.fragment';
import {BaseRichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/base-rich-text-block.fragment';
import {BaseSectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/base-section-panel.fragment';
import {BaseShopTheLookFragment} from '@amblique/contentful/app/contentful/fragments/shop-the-look/base-shop-the-look.fragment';

export const EditorialWrapperFragment = gql`
  ${BaseContainerFragment}
  ${BaseEditorialWrapperFragment}
  ${BaseRichTextBlockFragment}
  ${BaseSectionPanelFragment}
  ${BaseShopTheLookFragment}

  fragment EditorialWrapperFragment on EditorialWrapper {
    ...BaseEditorialWrapperFragment

    contentCollection {
      items {
        __typename
        ... on Container {
          ...BaseContainerFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
      }
    }
    contentCursorCollection {
      items {
        __typename
        ... on Container {
          ...BaseContainerFragment
        }
        ... on RichTextBlock {
          ...BaseRichTextBlockFragment
        }
        ... on SectionPanel {
          ...BaseSectionPanelFragment
        }
        ... on ShopTheLook {
          ...BaseShopTheLookFragment
        }
      }
    }
  }
`;
